import { format } from 'date-fns';
import { InlineStartBillingMenuItem } from '~/components/ServiceDetails/BillingSettingsSection/InlineStartBillingControl/InlineStartBillingControl.types';
import { getStartBillingSelection } from '~/components/ServiceDetails/BillingSettingsSection/InlineStartBillingControl/InlineStartBillingControl.utils';
import { serviceBillingModel, serviceCostModel, serviceModel } from '~/models';
import { autoBillingPeriodLabel } from '~/utils/service-billing/automatic-service-billing-period';
export const billingCellSubtitleTextsPath = 'billing.cellSubtitle';
function getStartBillingText(service, subtitleTexts) {
    const selection = getStartBillingSelection(service);
    switch(selection){
        case InlineStartBillingMenuItem.NextBillingDay:
            return subtitleTexts.startingNextBillingDay();
        case InlineStartBillingMenuItem.SpecificDate:
            {
                const date = serviceModel.startBillingAt(service);
                return date ? subtitleTexts.startingOnDate({
                    date: format(date, 'MMM d, yyyy')
                }) : subtitleTexts.startingNextBillingDay();
            }
        case InlineStartBillingMenuItem.AcceptanceDate:
            return subtitleTexts.startingOnAcceptance();
        case InlineStartBillingMenuItem.Today:
            return subtitleTexts.startingToday();
        case InlineStartBillingMenuItem.ManualInitiation:
            return subtitleTexts.onlyAfterManualInitiation();
    }
}
function getUpfrontText(service, subtitleTexts) {
    const isBilledUpfront = serviceBillingModel.isBilledUpfront(service.billing);
    const isQuarterly = serviceBillingModel.isQuarterly(service.billing);
    if (isQuarterly) {
        return isBilledUpfront ? subtitleTexts.upfrontQuarterly() : subtitleTexts.endOfQuarter();
    }
    return isBilledUpfront ? subtitleTexts.upfront() : subtitleTexts.endOfBillingCycle();
}
export function getSubtitle(service, t) {
    const subtitleTexts = t.billing.cellSubtitle;
    const costDisplayTexts = t.service.model.costDisplay;
    const billingTexts = t.billing;
    const commonDaysOfWeekTexts = t.common.daysOfWeek;
    if (!serviceBillingModel.isAutomatic(service.billing)) {
        return serviceCostModel.stringifyServiceCost(service.cost, undefined, billingTexts.periods, costDisplayTexts).unitCapDisplay;
    }
    const periodLabel = autoBillingPeriodLabel(service.billing, billingTexts.automaticBilling, commonDaysOfWeekTexts);
    if (!periodLabel) return undefined;
    const upfrontText = getUpfrontText(service, subtitleTexts);
    const startBillingText = getStartBillingText(service, subtitleTexts);
    return subtitleTexts.billedSummary({
        upfrontText,
        periodText: periodLabel.text.replace('Billed ', '').replace('Billed', ''),
        startText: startBillingText
    });
}
